import React from 'react';
import TablaNotificaciones from '../utils/TablaNotificaciones';

const NotificacionesLayer = () => {
    return (
        <>
        <TablaNotificaciones />
        </>
    );
};

export default NotificacionesLayer;